"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ariano-nel-polesine": {
    "dcc9976d": [{
      "hkey": "87bbd4ea",
      "slug": "ariano-nel-polesine",
      "name": "Ariano nel Polesine",
      "primary": true,
      "skipSearch": false
    }],
    "botteghino": [{
      "hkey": "87bbd4ea",
      "slug": "ariano-nel-polesine",
      "name": "Ariano nel Polesine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9d794bbd": [{
      "hkey": "87bbd4ea",
      "slug": "ariano-nel-polesine",
      "name": "Ariano nel Polesine",
      "primary": true,
      "skipSearch": false
    }],
    "monti": [{
      "hkey": "87bbd4ea",
      "slug": "ariano-nel-polesine",
      "name": "Ariano nel Polesine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d6992e73": [{
      "hkey": "87bbd4ea",
      "slug": "ariano-nel-polesine",
      "name": "Ariano nel Polesine",
      "primary": true,
      "skipSearch": false
    }],
    "torre": [{
      "hkey": "87bbd4ea",
      "slug": "ariano-nel-polesine",
      "name": "Ariano nel Polesine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;